/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { ReportResponseDtoStatus } from './reportResponseDtoStatus';
import type { CountryDto } from './countryDto';
import type { UserSummaryDto } from './userSummaryDto';
import type { EtiologyTypeDto } from './etiologyTypeDto';
import type { EtiologicalAgentDto } from './etiologicalAgentDto';
import type { DiagnosticProcedureDto } from './diagnosticProcedureDto';
import type { AssetDto } from './assetDto';

export interface ReportResponseDto {
  /** Report ID */
  id: string;
  /** Code of the report */
  code: string;
  /** Publication status of the report */
  status: ReportResponseDtoStatus;
  /** Country details */
  country: CountryDto;
  /** Type of animal */
  animalType?: string;
  /** Species */
  specie?: string;
  /** Wild type */
  wildType?: string;
  /** Latitude */
  latitude?: number;
  /** Longitude */
  longitude?: number;
  /** Inaccurate location flag */
  inaccurateLocation?: boolean;
  /** Detection date */
  detectionDate?: string;
  /** Surveillance type */
  surveillanceType?: string;
  /** Description */
  description?: string;
  /** Number of deaths */
  numberOfDeaths?: number;
  /** Number of sicks */
  numberOfSicks?: number;
  /** Population size */
  populationSize?: number;
  /** Human affected */
  humanAffected?: string;
  /** Domestic animal affected */
  domesticAnimalAffected?: string;
  /** Known cause */
  knownCause?: boolean;
  /** Order */
  order?: string;
  /** Version note */
  versionNote?: string;
  /** Version number */
  versionNumber: number;
  /** Is last version */
  isLastVersion: boolean;
  /** Created at */
  createdAt: string;
  /** User who created the report */
  user: UserSummaryDto;
  /** User who updated the report */
  userUpdater?: UserSummaryDto;
  /** Etiology type */
  etiologyType?: EtiologyTypeDto;
  /** Etiological agent */
  etiologicalAgent?: EtiologicalAgentDto;
  /** Diagnostic procedures */
  diagnosticProcedures: DiagnosticProcedureDto[];
  /** Assets */
  assets: AssetDto[];
}
